/**
 * QUÉ COMIDAS SE RECUADRAN SOLAS AL CRUZAR UN TRAMO DE LA CALIBRACIÓN (06-10).
 *
 * Al pasar de 50 g de cereales o de 20 g de frutos secos en el día, la proteína de esa
 * familia cambia de cuenta en todas las comidas, y las que ya estaban hechas se recuadran
 * solas (doc 57, F3) para que no se queden con «sobran X g» sin que el cliente haya tocado
 * nada.
 *
 * El fallo (José Luis, 06-10): «tengo las cantidades cuadradas a mi gusto con el ok verde,
 * doy guardar y modifica a su gusto las cantidades». Se recuadraba TODA comida con un
 * alimento de esa familia, también la que acababa de guardar a mano y que seguía cuadrada
 * con la calibración nueva. No había nada que ajustar y aun así se le cambiaban las
 * cantidades (la avena de 80 g a 45 g, el plátano de 200 g a 300 g).
 *
 * La regla: solo se recuadra la comida que, con los macros ya recalibrados, DEJA de estar
 * dentro del margen. La que sigue cuadrada no se toca.
 */
import { margenDe } from './exceso';

/** Los macros de una comida tal como los devuelve la calibración del día. Si de algún
 *  alimento no llega su fila, cuenta lo que ya tenía en pantalla. */
export const macrosRecalibrados = (alimentos = [], fila = []) =>
    (alimentos || []).reduce((total, a, i) => {
        const ef = fila?.[i]?.macros_efectivos || a?.macros_efectivos || {};
        return { P: total.P + (ef.P || 0), H: total.H + (ef.H || 0), G: total.G + (ef.G || 0) };
    }, { P: 0, H: 0, G: 0 });

/** La misma vara que el estado «cuadrada» de la tarjeta: los tres macros dentro del margen. */
export const sigueCuadrada = (servido, objetivo) =>
    ['P', 'H', 'G'].every((m) => Math.abs((objetivo?.[m] || 0) - (servido?.[m] || 0)) <= margenDe(objetivo?.[m]));

/**
 * Las comidas que hay que recuadrar al cruzar el tramo de `bloque`.
 *
 * `comidas` es la respuesta de la calibración (`{ C1: [{ macros_efectivos, bloque }, ...] }`)
 * y `objetivoDe(clave)` devuelve el objetivo `{ P, H, G }` de esa comida. Sin la respuesta
 * de la calibración no se puede saber si siguen cuadradas: se recuadran todas, como antes.
 */
export const comidasARecuadrar = ({ orden = [], mealsData = {}, bloque, comidas = null, objetivoDe }) =>
    orden.filter((k) => {
        if (k === 'Intra' || k === 'Post') return false;
        const comida = mealsData?.[k];
        if (!comida || comida.modo === 'manual') return false;      // Manual es «lo dejo como lo pongas»
        const alimentos = comida.alimentos || [];
        if (!alimentos.some((a) => a.bloque === bloque)) return false;
        if (!comidas || !objetivoDe) return true;
        return !sigueCuadrada(macrosRecalibrados(alimentos, comidas[k]), objetivoDe(k));
    });
